import React from 'react';
import "../Figure.css"


function Figure25() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
            <th> </th>
              <th> Zn concentration after incubation (30min)</th>
              <th> Zn concentration after removal of the blank </th>
              <th> Zn uptake </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Blank EC20 </th>
              <td> 0.17 mg/L </td>
              <td> 0 mg/L </td>
              <td> - mg/L </td>
            </tr> 
            <tr>
              <th> Blank SpaC </th>
              <td> 0.15 mg/L </td>
              <td> 0 mg/L </td>
              <td> - mg/L </td>
            </tr> 
            <tr>
              <th> Water </th>
              <td> 1.41 mg/L </td>
              <td> - mg/L </td>
              <td> - mg/L </td>
            </tr> 
            <tr>
            <th> EC20 </th>
              <td> 0.5 mg/L </td>
              <td> 0.33 mg/L </td>
              <td> 0.91 mg/L </td>
            </tr>
            <tr> 
            <th> SpaC </th>
              <td> 0.71 mg/L </td>
              <td> 0.56 mg/L </td>
              <td> 0.7 mg/L </td>
            </tr> 
            <tr>
              <th className="colored-cell" colSpan="3"> Uptake difference </th>
              <th className="colored-cell"> 0.21 mg/L </th>
            </tr> 
          </tbody>
        </table>
    </div>
  );
}

export default Figure25;